(function () {
  'use strict';

  var configEl = document.getElementById('lp-hh-config');
  if (!configEl) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  /* Substitui {tempo} pelo texto configurado na oferta */
  if (CONFIG.offerDurationText) {
    document.querySelectorAll('[data-lp-hh-offer-text]').forEach(function (el) {
      el.textContent = el.textContent.replace(/\{tempo\}/g, CONFIG.offerDurationText);
    });
  }

  /* Repasse de UTM: landing → checkout */
  (function applyCheckoutLinks() {
    if (!CONFIG.checkoutUrl) return;

    var params = new URLSearchParams(window.location.search);

    function buildUrl(baseUrl) {
      var url;

      try {
        url = new URL(baseUrl, window.location.origin);
      } catch (e) {
        return baseUrl;
      }

      var utmPadrao = CONFIG.utmPadrao || {};
      Object.keys(utmPadrao).forEach(function (k) {
        if (utmPadrao[k]) url.searchParams.set(k, utmPadrao[k]);
      });

      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        if (params.get(k)) url.searchParams.set(k, params.get(k));
      });

      return url.toString();
    }

    document.querySelectorAll('.js-lp-hh-checkout').forEach(function (a) {
      var base = a.getAttribute('data-lp-hh-url') || CONFIG.checkoutUrl;
      if (base) a.href = buildUrl(base);
    });
  })();

  /* Contador regressivo */
  (function initCountdown() {
    var KEY = CONFIG.storageKey || 'hh-flash-sale-deadline';
    var minutes = CONFIG.durationMinutes || 10;
    var DUR = minutes * 60 * 1000;

    function getDeadline() {
      if (CONFIG.mode === 'fixed' && CONFIG.fixedDeadline) {
        return new Date(CONFIG.fixedDeadline).getTime();
      }

      try {
        var saved = parseInt(localStorage.getItem(KEY), 10);
        if (saved && saved > Date.now()) return saved;
        var novo = Date.now() + DUR;
        localStorage.setItem(KEY, String(novo));
        return novo;
      } catch (e) {
        return Date.now() + DUR;
      }
    }

    var deadline = getDeadline();

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var r = deadline - Date.now();

      if (r <= 0) {
        if (CONFIG.mode === 'rolling' && CONFIG.onExpire === 'restart') {
          deadline = Date.now() + DUR;
          try {
            localStorage.setItem(KEY, String(deadline));
          } catch (e) {}
          r = DUR;
        } else if (CONFIG.onExpire === 'redirect' && CONFIG.redirectUrl) {
          window.location.href = CONFIG.redirectUrl;
          return;
        } else {
          r = 0;
        }
      }

      var total = Math.floor(r / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      document.querySelectorAll('.js-lp-hh-h').forEach(function (el) {
        el.textContent = pad(h);
      });
      document.querySelectorAll('.js-lp-hh-m').forEach(function (el) {
        el.textContent = pad(m);
      });
      document.querySelectorAll('.js-lp-hh-s').forEach(function (el) {
        el.textContent = pad(s);
      });

      var inline = pad(h) + ':' + pad(m) + ':' + pad(s);
      document.querySelectorAll('.js-lp-hh-timer-inline').forEach(function (el) {
        el.textContent = inline;
      });
    }

    tick();
    setInterval(tick, 1000);
  })();
})();
